var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.595825 6.39412L5.95775 9.30031L8.83978 14.7072C8.93117 14.8761 9.10483 14.9836 9.29676 14.9836H9.33332C9.53744 14.9683 9.71109 14.8362 9.78421 14.6426L14.7227 1.12859C14.7927 0.938118 14.747 0.723073 14.6038 0.578685C14.4607 0.434298 14.2474 0.388217 14.0585 0.458875L0.662849 5.44178C0.470917 5.51244 0.339915 5.69062 0.324682 5.89645C0.30945 6.10228 0.416079 6.29582 0.595825 6.39412ZM9.20536 13.1896L6.97834 9.00846L12.9343 3.00255L9.20536 13.1896ZM6.24717 8.26809L12.2001 2.26218L2.09777 6.0224L6.24717 8.26809Z",
    fill: "#667982"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend5);
export default __webpack_public_path__ + "static/media/Send (5).55e1dda7.svg";
export { ForwardRef as ReactComponent };